import getSuccessiveDisplayDates from './getSuccessiveDisplayDates';
import TimeConstants from './TimeConstants';
import { DisplayDate, startOfWeek } from 'owa-datetime';

/**
 * Get an array of DisplayDates with the days of the week that include the given date.
 */
export default function getWeekDays(date: DisplayDate, weekStartsOn: number): DisplayDate[] {
    return getSuccessiveDisplayDates(startOfWeek(date, weekStartsOn), TimeConstants.DaysInOneWeek);
}
